import { EMPTY_FIELD_PLACEHOLDER } from '@Constants';

// import { MInput } from '@Components/Base';
import { TenderPriceResponse } from '@Types/api/form/tenderRequest/TenderPriceResponse';
import { TenderTableData } from './type';
import PricingInput from '../components/PricingInput/PricingInput';

export const pricingMapper = (
  data: TenderPriceResponse,
  priceType: string,
  handleChangeDataItem: (changedDataItem: TenderPriceResponse) => void
): TenderTableData => {
  return {
    key: data.matCode,
    matCode: data.matCode || EMPTY_FIELD_PLACEHOLDER,
    materialDescription: data.matDesc || EMPTY_FIELD_PLACEHOLDER,
    unit: data.unitName || EMPTY_FIELD_PLACEHOLDER,
    reqQty: data.reqQty,
    lpoNo: (
      <PricingInput
        handleChangeDataItem={(value) =>
          handleChangeDataItem({
            ...data,
            prevLPONo: String(value),
          })
        }
        disable={priceType === 'LOI'}
        initialValue={data.prevLPONo}
        placeholder="Insert LPO NO"
        priceType={priceType}
      />
    ),
    rate: (
      <PricingInput
        handleChangeDataItem={(value) =>
          handleChangeDataItem({
            ...data,
            prevRate: Number(value),
          })
        }
        disable={priceType === 'LPO'}
        initialValue={data.prevRate}
        placeholder="Insert Rate"
        priceType={priceType}
      />
    ),
  };
};

export const pricingDataSourceMap = (
  data: Array<TenderPriceResponse> | null | undefined,
  priceType: string,
  handleChangeDataItem: (changedDataItem: TenderPriceResponse) => void
): Array<TenderTableData> => {
  if (data == null) return [];

  return data.map((item) =>
    pricingMapper(item, priceType, handleChangeDataItem)
  );
};
